import { FiAppTextSharedModule } from './../app-text/app-text.module';
import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { FiTimeRangeMenuComponent } from './fi-time-range-menu.component';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FiDatePickerModule } from '../fi-date-picker';
import { InfoIconModule } from '../info-icon/info-icon.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatMenuModule,
        FiAppTextSharedModule,
        MatIconModule,
        FiDatePickerModule,
        InfoIconModule,
    ],
    declarations: [FiTimeRangeMenuComponent],
    exports: [FiTimeRangeMenuComponent],
})
export class FiTimeRangeMenuModule {}
